/**
 * Yandex Metrika утилиттері
 *
 * Адблокерді айналып өту үшін:
 * - Скрипт жүктелмесе, жым-жынды өтеді, консольде қате жоқ
 * - initMetrika() шақыруды App.js ішінде жасаймыз
 */

const METRIKA_ID = process.env.REACT_APP_YANDEX_METRIKA_ID;

let metrikaLoaded = false;

/**
 * Yandex Metrika скриптін жүктеп, инициализациялау
 */
export function initMetrika() {
  if (!METRIKA_ID || metrikaLoaded) return;

  // ym функциясын анықтау (скрипт жүктелмесе де жұмыс істейді)
  window.ym = window.ym || function () {
    (window.ym.a = window.ym.a || []).push(arguments);
  };
  window.ym.l = Date.now();

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://mc.yandex.ru/metrika/tag.js';

  script.onload = () => {
    metrikaLoaded = true;
    try {
      window.ym(METRIKA_ID, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        trackHash: true,
        ecommerce: 'dataLayer',
      });
    } catch (e) {
      // Инициализация қатесін жым-жынды өткіземіз
    }
  };

  script.onerror = () => {
    // Скрипт жүктелмесе (адблокер блоктаса), ештеңе жасамаймыз
  };

  document.head.appendChild(script);
}

/**
 * Мақсатты оқиға жіберу (reachGoal аналогі)
 * @param {string} target - Мақсат атауы
 * @param {Object} params - Қосымша параметрлер
 */
export function trackGoal(target, params = {}) {
  try {
    if (window.ym && METRIKA_ID) {
      window.ym(METRIKA_ID, 'reachGoal', target, params);
    }
  } catch (e) {
    // Жым-жынды өткіземіз
  }
}

/**
 * Бет көруді жіберу (SPA навигация үшін)
 * @param {string} url - Бет URL
 */
export function trackPageView(url) {
  try {
    if (window.ym && METRIKA_ID) {
      window.ym(METRIKA_ID, 'hit', url);
    }
  } catch (e) {
    // Жым-жынды өткіземіз
  }
}

/**
 * Пайдаланушы параметрлерін жіберу
 * @param {Object} params - Пайдаланушы параметрлері
 */
export function trackUserParams(params) {
  try {
    if (window.ym && METRIKA_ID) {
      window.ym(METRIKA_ID, 'userParams', params);
    }
  } catch (e) {
    // Жым-жынды өткіземіз
  }
}

const yandexMetrika = {
  initMetrika,
  trackGoal,
  trackPageView,
  trackUserParams,
};

export default yandexMetrika;